import type { ReactNode } from 'react';

export const symbol_chip_extraction: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M257.5-279Q335-193 451-182q12 2 20.5 10.5T480-151q0 14-12 22t-27 6q-138-15-229.5-117T120-481q0-139 91.5-241T441-839q15-2 27 6t12 22q0 12-8.5 20.5T451-780q-116 11-193.5 97T180-481q0 116 77.5 202ZM724-450H390q-13 0-21.5-8.5T360-480q0-13 8.5-21.5T390-510h334l-92-93q-9-9-9-21t9-21q9-9 21-9t21 9l144 144q9 9 9 21t-9 21L674-315q-9 9-21 8.5t-21-9.5q-9-9-9-21t9-21l92-92Z"
		/>
	</svg>
);
